import moment from 'moment-timezone';
import { PricingCopilotMatrixOverview } from './pricing-copilot-matrix-overview';
import { PricingCopilotMatrixOverviewSuggestion } from './pricing-copilot-matrix-overview-suggestion';
import { PricingCopilotMatrixProductDetailGraph } from './pricing-copilot-matrix-product-detail-graph';
import { PricingCopilotMatrixProductDetailMetrics } from './pricing-copilot-matrix-product-detail-metrics';
import { PricingCopilotMatrixProductDetailOther } from './pricing-copilot-matrix-product-detail-other';

export class PricingCopilotMatrixProductDetail {
	public productEffectiveDateList: string[];
	public productUsageList: number[];
	public productTermList: number[];
	public productGraph: PricingCopilotMatrixProductDetailGraph[];
	public productMetrics: PricingCopilotMatrixProductDetailMetrics;
	public productPartial: PricingCopilotMatrixOverview[];
	public productClosed: PricingCopilotMatrixOverview[];
	public productSuggestion: PricingCopilotMatrixOverviewSuggestion;
	public productOthers: PricingCopilotMatrixProductDetailOther[];

	public effectiveDateList: { name: string; value: string }[];
	public usageList: { name: string; value: number }[];

	constructor(pricingCopilotProductDetail?: PricingCopilotMatrixProductDetail, usageUnit = 'kWh') {
		Object.assign(this, pricingCopilotProductDetail);

		if (this.productEffectiveDateList?.length) {
			this.effectiveDateList = this.productEffectiveDateList.map(date => ({
				name: moment(date).format('M/D/YYYY'),
				value: moment(date).format('YYYY-MM-DD'),
			}));
		}

		if (this.productUsageList?.length) {
			this.usageList = this.productUsageList.map(usage => ({
				name: `${usage.toLocaleString('en-US')} ${usageUnit}`,
				value: usage,
			}));
		}
	}
}
